import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { User } from '../../../models/user';
import { AuthAppService } from '../../../services/auth-app/auth-app.service';
import { MegaMenuMobileComponent } from '../mega-menu-mobile/mega-menu-mobile.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  trinityLoggedUser: any;
  showBusinessDashboard = true;
  isAgreedProvidersTandC: boolean;
  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }
  constructor(
    public router: Router,
    private authService: AuthAppService,
    private dialog: MatDialog
  ) {
    this.authService.trinityLoggedUser.subscribe((userData: any) => {
      this.isAgreedProvidersTandC = userData?.header_detail?.terms_and_pricing;
      this.trinityLoggedUser = userData;
    });
  }

  @Input() user: User;

  activeMenu: string | null = null;

  isDashboard = false;
  isSearchEnabled = false;
  isServicePage = false;
  isOnlySearchPage = false;
  isMobileView = false;
  ngOnInit(): void {
    this.setDefaultData();
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobileView = window.innerWidth <= 768;
  }
  setDefaultData() {
    const url_split = this.router.url.split('/');
    if (url_split[1] === 'business' || url_split[1] === 'wellbeing') {
      this.isDashboard = true;
    } else {
      this.isDashboard = false;
    }
    if (url_split[1] === 'search' || url_split[1] === 'category') {
      this.isSearchEnabled = true;
    } else {
      this.isSearchEnabled = false;
    }
    if (url_split[1] === 'search') {
      this.isOnlySearchPage = true;
    } else {
      this.isOnlySearchPage = false;
    }
    this.isServicePage = url_split[1] === 'search';
  }

  checkIsSearchPage() {
    this.setDefaultData();
    return this.isSearchEnabled;
  }

  checkIsOnlySearchPage() {
    this.setDefaultData();
    return this.isOnlySearchPage;
  }

  toggleMenu(menu: string) {
    if (this.activeMenu === menu) {
      this.activeMenu = null;
    } else {
      this.activeMenu = menu;
    }
  }

  menuClosed(menu: string) {
    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }
  }

  openMobileMainMenu(menu: string) {
    const backdropClass =
      this.isDashboard || this.isSearchEnabled ? ['mobile-mega-menu-backdrop', 'full'] : 'mobile-mega-menu-backdrop';
    this.dialog.open(MegaMenuMobileComponent, {
      width: '100%',
      maxWidth: '375px',
      backdropClass: backdropClass,
      panelClass: ['mobile-mega-menu-panel', 'popup-container'],
      position: {
        top: '67px'
      },
      data: {
        menu
      }
    });
  }

  loginPage() {
    this.router.navigate(['/login']);
  }

  navigateToBusinessDashboard() {
    console.warn(this.trinityLoggedUser);
    const business_id: any = this.trinityLoggedUser?.businesses[0]?.id;
    const dashboardUrl = 'business/' + business_id + '/profile';
    this.router.navigate([dashboardUrl]);
  }

  navigateToLogin() {
    if (this.router.url.indexOf('/login?') === -1) {
      this.router.navigate(['/login'], { queryParams: { redirect: this.router.url } });
    } else {
      this.router.navigate(['/login'], { queryParams: { redirect: '' } });
    }
  }
  navigateToProviderLogin() {
    if (this.router.url.indexOf('/login?') === -1) {
      this.router.navigate(['/login'], { queryParams: { redirect: this.router.url, action: 'provider_signin' } });
    } else {
      this.router.navigate(['/login'], { queryParams: { redirect: '', action: 'provider_signin' } });
    }
  }
  navigateToSignup() {
    if (this.router.url.indexOf('/login?') === -1) {
      this.router.navigate(['/login'], { queryParams: { redirect: this.router.url, action: 'signup' } });
    } else {
      this.router.navigate(['/login'], { queryParams: { redirect: '', action: 'signup' } });
    }
  }
}
